import type { SortingFn } from '@tanstack/react-table'

import { sortingFns } from '@tanstack/react-table'
import { prop } from 'lodash/fp'

const getGroupName = prop('original.optimization_group_name')
export const ogNameAndOrder: SortingFn<any> = (rowA, rowB) => {
	if (rowA.depth === 0) {
		if (rowA.groupingValue === 'null') {
			return -1
		}

		return getGroupName(rowA) > getGroupName(rowB)
			? 1
			: getGroupName(rowA) < getGroupName(rowB)
				? -1
				: 0
	}

	return rowA.original.order > rowB.original.order
		? 1
		: rowA.original.order < rowB.original.order
			? -1
			: 0
}

export const ogNameAndPcName: SortingFn<any> = (rowA, rowB) => {
	if (rowA.depth === 0) {
		if (rowA.groupingValue === 'undefined') {
			return -1
		}

		return sortingFns.alphanumeric(rowA, rowB, 'optimization_group_name')
	}

	return sortingFns.alphanumeric(rowA, rowB, 'name')
}
